import { render, staticRenderFns } from "./ServiceEdit.vue?vue&type=template&id=f9e50988&"
import script from "./ServiceEdit.vue?vue&type=script&lang=ts&"
export * from "./ServiceEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceEdit.vue?vue&type=style&index=0&id=f9e50988&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports